/* Deep Fried Lore shared carousel controls */
(function(){
  function initShelves(){
    document.querySelectorAll('[data-dfl-merch-scroll-shell]').forEach(function(shell){
      if(shell.dataset.dflMerchReady==='1')return;
      shell.dataset.dflMerchReady='1';
      var track=shell.querySelector('[data-dfl-merch-track]');
      var prev=shell.querySelector('[data-dfl-merch-prev]');
      var next=shell.querySelector('[data-dfl-merch-next]');
      if(!track||!prev||!next)return;
      var update=function(){
        var max=Math.max(0,track.scrollWidth-track.clientWidth);
        prev.disabled=track.scrollLeft<=4;
        next.disabled=track.scrollLeft>=max-4;
      };
      shell.querySelectorAll('button[data-dfl-merch-prev],button[data-dfl-merch-next]').forEach(function(button){
        button.addEventListener('click',function(){
          var card=track.querySelector('.dfl-merch-product');
          if(!card)return;
          var width=card.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||17);
          track.scrollBy({left:width*(button.hasAttribute('data-dfl-merch-prev')?-1:1),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        });
      });
      track.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update,{passive:true});
      update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initShelves,{once:true});
  else initShelves();
  document.addEventListener('shopify:section:load',initShelves);
})();